{
  "instructions": "Enter your email address and we'll send you an email with instructions to reset your password.",
  "forgot-your-pass": "Forgot your password?",
  "send-email": "Send email",
  "email": "Email",
  "go-login": "Back to login",
  "email-sent": "Email Sent",
  "error" : "An Error Occurred",
  "emailLabel": "Email",
  "lost-password": "Lost password?",
  "send-link": "Send login link via email",
  "login": "Login",
  "error-message": "There was an error. Please try again.",
  "password": "Password",
  "back": "Back",
  "type-email-message": "Type your email address, you will receive a secret to change your password.",
  "copy-secret-message": "Copy the secret sent via email and paste it in the corresponding field, then type in your new password and confirm it.",
  "secret": "Secret",
  "confirm-password": "Confirm Password",
  "change-password": "Change Password",
  "request-secret": "Request Secret",
  "request-new-secret": "Request new secret",
  "already-have-secret": "I already have a secret",
  "email-sent-success": "Email sent!",
  "welcome": "Welcome.",
  "error-try-again": "There was an error, please try again.",
  "sign-in-with-oauth": "Sign in",
  "oauth-error": "We couldn't complete sign-in. Please try again.",
  "redirecting": "Redirecting…",
  "email-bootstrap-error": "This link is invalid or has expired. Request a new one.",
  "email-bootstrap-confirm": "Continue signing in",
  "degraded-banner": "Connection lost. Retrying your session…",
  "wopi-loading": "Opening the editor…",
  "wopi-reauth": "We couldn't refresh the editor session. Retry to keep editing.",
  "or": "or",
  "email-link-title": "Sign in with email",
  "email-link-description": "We'll email you a secure sign-in link.",
  "email-sent-detail": "We sent a sign-in link to {{email}}.",
  "back-to-sign-in": "Back to sign in",
  "password-updated": "Your password was updated."
}
